const type = 'SET_ATTENDANCE_NOTE';

const setAttendanceNote = (data) => ({
  data,
  type,
});

export default setAttendanceNote;
